<template>
    <div>
        <div style="font-size: 16px; max-width: 800px; margin-left: auto; margin-right: auto; margin-top: 60px; text-align: center">
            <div style="font-size: 36px;"><b>Announcement</b></div>
            <br>
            The feature you're searching for is now avallable on <b>TunaiPro</b> - an enhanced version of Tunai, offering more powerful tools and
            greater control.
            <br>
            <br>
            TunaiPro is accessible across all major platforms.
            <br>
            <br>
            <br>
            Please choose from the options below to get started.
            <br>
            <br>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=io.tunai.pro&amp;hl=en_SG"
                style="margin-left: 10px; margin-right: 10px; margin-bottom: 5px"><img src="@/assets/image/notice/google.png" style="width: 200px"></a>
            <a target="_blank" href="https://apps.apple.com/my/app/tunaipro/id6470448863"
                style="margin-left: 10px; margin-right: 10px; margin-bottom: 5px"><img src="@/assets/image/notice/apple.png" style="width: 200px"></a>
            <a target="_blank" href="https://apps.microsoft.com/detail/9mzx4khh89wv?hl=en-US&amp;gl=US"
                style="margin-left: 10px; margin-right: 10px; margin-bottom: 5px"><img src="@/assets/image/notice/microsoft.png" style="width: 200px"></a>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MenuStaff',
    components: {
    },
    data(){
        return{
            addToggle: false,
            selectedTab: 'list'
        }
    },
}
</script>